module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/~/axios/index.js
// module id = 1364
// module chunks = 0